import { ComponentType, PropsWithChildren, MouseEvent } from 'react';

import { LinkIconButton } from '@atlaskit/button/new';
import { NewCoreIconProps } from '@atlaskit/icon';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import Tooltip from '@atlaskit/tooltip';

import * as styles from './focused-navigation.style';

type Props = {
  backButtonUrl: string;
  backButtonTooltip: string;
  customBackIcon?: ComponentType<PropsWithChildren<NewCoreIconProps>>;
  onBackButtonClick?: () => void;
};

// Note this component doesn't actually use atlaskit/navigation-next, this is just a legacy name
const FocusedNavigationNext = ({
  backButtonUrl,
  customBackIcon: BackIcon,
  backButtonTooltip,
  onBackButtonClick,
}: Props) => {
  const handleBackButtonClick = (e: MouseEvent) => {
    if (onBackButtonClick) {
      e.preventDefault();
      onBackButtonClick();
    }
  };

  return (
    <styles.FocusedNavigationWrapper>
      <Tooltip content={backButtonTooltip} position="right">
        <LinkIconButton
          href={backButtonUrl}
          onClick={handleBackButtonClick}
          icon={iconProps => {
            if (BackIcon) {
              return <BackIcon {...iconProps} />;
            }
            return <ArrowLeftIcon {...iconProps} />;
          }}
          label={backButtonTooltip}
          appearance="subtle"
        ></LinkIconButton>
      </Tooltip>
    </styles.FocusedNavigationWrapper>
  );
};

// eslint-disable-next-line import/no-default-export
export default FocusedNavigationNext;
